<template>
    <div v-if="token" :class="showBold?'price_box class_bold':'price_box'">
        <!-- 原价*数量和特价*数量 -->
        <template v-if="couponPriceDisplay.show">
            <div class="coupon_price_box">
                <div class="coupon_price_main">
                    <span>￥{{ couponPriceDisplay.couponPrice }}</span>
                    <img :src="$util.img('/upload/uniapp/discount_after.png')" alt="折后约" />
                </div>
                <span class="coupon_price_origin">
                    ￥{{ couponPriceDisplay.originPrice }}
                    <template v-if="info.unit">/{{ info.unit }}</template>
                </span>
            </div>
        </template>
        <template v-if="returnGoodsType === 'seckill'">
            <div class="price_style_1">
                <template v-if="info.goods_min!==undefined && info.goods_min!==null && info.num >= info.goods_min">
                    <template v-if="info.goods_limit!==undefined && info.goods_limit!==null && info.goods_limit > 0 && info.num>info.goods_limit">
                        <span>￥{{ info.price }} x {{ parseInt(info.num)-parseInt(info.goods_limit) }}</span>
                        <span>￥{{ info.discount_price }} x {{ info.goods_limit }}</span>
                    </template>
                    <template v-else>
                        <div style="display: flex;align-items: center;">
                            <span>￥{{ info.discount_price }}</span>
                            <template v-if="info.discount_price !== info.price">
                                <del class="del_text">￥{{ info.price }}</del>
                            </template>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <span>￥{{ info.price }}</span>
                </template>
            </div>
        </template>
        <template v-if="!couponPriceDisplay.show && (returnGoodsType === 'default'||returnGoodsType === 'getfree')">
            <div :class="showNum?'price_style_2_mini price_style_2':'price_style_2'">
                <template v-if="showNum">
                    <span>￥{{ info.price!=info.discount_price?info.discount_price:info.price }} x {{ info.num }}</span>
                </template>
                <template v-else>
                    <template v-if="info.discount_price !== info.price">
                        <span>￥{{ info.discount_price }}</span>
                        <del class="del_text">￥{{ info.price }}</del>
                    </template>
                    <template v-else>
                        <span>￥{{ info.price }}</span>
                    </template>
                </template>
            </div>
        </template>
        <template v-if="returnGoodsType === 'discount'">
             <div :class="showNum?'price_style_3_mini price_style_3':'price_style_3'">
                <div>
                    <span>{{ returnDiscountPrice.price }} </span>
                    <template v-if="!showNum">
                        <del class="del_text">{{ returnDiscountPrice.del_price }}</del>
                    </template>
                    <template v-if="showNum&&returnDiscountPrice.discount_price==''"> 
                        <span>x {{ info.num }}</span>
                    </template>
                </div>
                <span>{{ returnDiscountPrice.discount_price }}</span>
             </div>
        </template>
        <template v-if="returnGoodsType === 'wholesale'">
            <div :class="showNum?'price_style_3_mini price_style_3':'price_style_3'">
                <div>
                    <span>{{ returnWholesalePrice.price }} </span>
                    <template v-if="!showNum">
                        <del class="del_text">{{ returnWholesalePrice.del_price }}</del>
                    </template>
                    <template v-if="showNum&&returnWholesalePrice.discount_price==''"> 
                        <span>x {{ info.num }}</span>
                    </template>
                </div>
                <span>{{ returnWholesalePrice.discount_price }}</span>
             </div>
        </template>
        <!-- 用作测试辅助验证 -->
        <!-- <div class="price_box_test">
            <span>{{ info.goods_name }}</span>
            <span>returnGoodsType: {{ returnGoodsType }}</span>
            <span>info.goods_min: {{ info.goods_min }}</span>
            <span>info.goods_limit: {{ info.goods_limit }}</span>
            <span>info.num: {{ info.num }}</span>
            <span>info.price: {{ info.price }}</span>
            <span>info.discount_price: {{ info.discount_price }}</span>
        </div> -->
    </div>
</template>

<script>
// 字段说明
// goods_min: 最小购买数量
// goods_limit: 限购数量
// price: 原价
// discount_price: 特价
// num: 购买数量
import { mapGetters } from "vuex"
const GOODS_TYPES = {
    DEFAULT: 'default',
    GETFREE: 'getfree',
    SECKILL: 'seckill',
    DISCOUNT: 'discount',
    WHOLESALE: 'wholesale',
    BUNDLING: 'bundling'
};

export default {
    name: 'cartAndOrder_price',
    props: {
        info: {
            type: Object,
            required: true
        },
        // 辅助判断商品类型
        goodsType: {
            type: String,
            default: ''
        },
        showNum:{
            type:Boolean,
            default:false
        },
        showBold:{
            type:Boolean,
            default:false
        },
        showCouponPrice:{
            type:Boolean,
            default:false
        }
    },
    computed: {
        ...mapGetters(["token"]),
        returnGoodsType() {
            const { info } = this;
            // 换购商品判断
            if (info.is_getfree || (info.get_free_goods && Object.keys(info.get_free_goods).length > 0)) {
                return GOODS_TYPES.GETFREE;
            }
            // 秒杀商品判断
            if (info.promotion_label === 'seckill') {
                return GOODS_TYPES.SECKILL;
            }
            // 折扣商品判断
            if (info.promotion_label === 'discount') {
                return GOODS_TYPES.DISCOUNT;
            }
            // 阶梯商品判断
            if (info.promotion_label === 'wholesale' || 
                (info.wholesale_goods_id !== undefined && 
                 info.wholesale_goods_id !== null && 
                 info.wholesale_goods_id >= 0)) {
                return GOODS_TYPES.WHOLESALE;
            }
            // 组合套餐判断
            if (this.goodsType === 'bundling') {
                return GOODS_TYPES.BUNDLING;
            }
            return GOODS_TYPES.DEFAULT;
        },
        returnDiscountPrice(){
            let obj = {
                del_price:'', // 需要显示的划线价格，只有当只显示原价时，才显示划线价格
                price:'', // 原价
                real_price:0, // 实际价格
                discount_price:'', // 特价
                real_discount_price:0, // 实际特价
            };
            const { info } = this;
            // 判断是否达到起购数量
            if(info.num<info.goods_min){
                obj.price = `￥${info.price}`;
                obj.real_price = info.price*info.num;
            }else{
                let num_multiple = info.promotion_info.num_multiple;
                // 判断是否达到限购数量
                if(info.goods_limit==0){// 不限制购买数量
                    if(num_multiple>1){
                        let remainder = info.num%num_multiple;
                        if(remainder>0){
                            if(info.num-remainder>0){
                                obj.price = `￥${info.price} x ${remainder}`;
                                obj.real_price = info.price*remainder;
                                obj.discount_price = `￥${info.discount_price} x ${info.num-remainder}`;
                                obj.real_discount_price = info.discount_price*(info.num-remainder);
                            }else{
                                obj.price = `￥${info.price}`;
                                obj.real_price = info.price*remainder;
                            }
                        }else{
                            obj.price = `￥${info.discount_price}`;
                            if(info.discount_price !== info.price){
                                obj.del_price = `￥${info.price}`;
                            }
                            obj.real_price = info.discount_price*info.num;
                        }
                    }else{
                        obj.price = `￥${info.discount_price}`;
                        if(info.discount_price !== info.price){
                            obj.del_price = `￥${info.price}`;
                        }
                        obj.real_price = info.discount_price*info.num;
                    }
                }else{
                    if(num_multiple>1){
                        if(info.num>info.goods_limit){
                            let quotient = Math.floor(info.goods_limit/num_multiple)*num_multiple;
                            obj.price = `￥${info.price} x ${info.num-quotient}`;
                            obj.real_price = info.price*(info.num-quotient);
                            obj.discount_price = `￥${info.discount_price} x ${quotient}`;
                            obj.real_discount_price = info.discount_price*quotient;
                        }else{
                            let remainder = info.num%num_multiple;
                            if(remainder>0){
                                if(info.num-remainder>0){
                                    obj.price = `￥${info.price} x ${remainder}`;
                                    obj.real_price = info.price*remainder;
                                    obj.discount_price = `￥${info.discount_price} x ${info.num-remainder}`;
                                    obj.real_discount_price = info.discount_price*(info.num-remainder);
                                }else{
                                    obj.price = `￥${info.price}`;
                                    obj.real_price = info.price*remainder;
                                }
                            }else{
                                obj.price = `￥${info.discount_price}`;
                                if(info.discount_price !== info.price){
                                    obj.del_price = `￥${info.price}`;
                                }
                                obj.real_price = info.discount_price*info.num;
                            }
                        }
                    }else{
                        if(info.num>info.goods_limit){
                            obj.price = `￥${info.price} x ${info.num-info.goods_limit}`;
                            obj.real_price = info.price*(info.num-info.goods_limit);
                            obj.discount_price = `￥${info.discount_price} x ${info.goods_limit}`;
                            obj.real_discount_price = info.discount_price*info.goods_limit;
                        }else{
                            obj.price = `￥${info.discount_price}`;
                            if(info.discount_price !== info.price){
                                obj.del_price = `￥${info.price}`;
                            }
                            obj.real_price = info.discount_price*info.num;
                        }
                    }
                }
            }
            return obj;
        },
        returnWholesalePrice() {
            let obj = {
                price:'',
                discount_price:'',
                del_price:''
            }
            let { num, price } = this.info;
            let priceJson = this.info.promotion_info.price_json;
            let arr = priceJson.filter(item=> num>=parseInt(item.num));
            arr = arr.filter(item=> item !== '');
            if(arr.length>0){
                let t_info = arr[arr.length-1];
                // 限制购买数量
                if(parseInt(t_info.limit_num) > 0){
                    if(num > parseInt(t_info.limit_num)){
                        obj.price = `￥${price} x ${num-parseInt(t_info.limit_num)}`;
                        obj.discount_price = `￥${t_info.price} x ${parseInt(t_info.limit_num)}`;
                    }else{
                        obj.price = `￥${t_info.price}`;
                        if(price!==t_info.price){
                            obj.del_price = `￥${price}`;
                        }
                    }
                }
                // 没有限制购买数量
                if(parseInt(t_info.limit_num)===0){
                    obj.price = `￥${t_info.price}`;
                    if(price!==t_info.price){
                        obj.del_price = `￥${price}`;
                    }
                }
            }else{
                obj.price = `￥${price}`;
            }
            return obj;
        },
        couponPriceDisplay() {
            const couponPrice = Number(this.info.coupon_price)
            if (!this.showCouponPrice || this.showNum || !couponPrice || couponPrice <= 0) {
                return {
                    show: false,
                    couponPrice: '',
                    originPrice: ''
                }
            }

            if (this.returnGoodsType !== GOODS_TYPES.DEFAULT && this.returnGoodsType !== GOODS_TYPES.GETFREE) {
                return {
                    show: false,
                    couponPrice: '',
                    originPrice: ''
                }
            }

            const discountPrice = Number(this.info.discount_price)
            const originPrice = discountPrice > 0 && Number(this.info.price) !== discountPrice
                ? this.info.discount_price
                : this.info.price
            if (Number(originPrice) === couponPrice) {
                return {
                    show: false,
                    couponPrice: '',
                    originPrice: ''
                }
            }

            return {
                show: true,
                couponPrice: (typeof this.info.coupon_price == 'string'?this.info.coupon_price:this.info.coupon_price.join('~')),
                originPrice
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.class_bold{
    font-weight: bold;
}
.price_box{
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
}
.price_style_1{
    display: flex;
    flex-direction: column;
    line-height: initial;
    span{
        color: #333;
    }
}
.price_box_test{
    position: absolute;
    right: 200px;
    width: 200px;
    background: rgba(0,0,0,0.5);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    color: #fff;
    line-height: initial;
    font-size: 12px;
}
.price_style_2{
    display: flex;
    color: #333;
}
.coupon_price_box{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: initial;
    gap: 4px;
}
.coupon_price_main{
    display: flex;
    align-items: center;
    gap: 4px;
    span{
        color: #32BC6F;
        font-weight: bold;
    }
    img{
        width: 53px;
        height: 17px;
    }
}
.coupon_price_origin{
    color: #999;
    font-size: 12px;
    font-weight: bold;
}
.price_style_2_mini{
    justify-content: flex-end;
}
.price_style_3{
    display: flex;
    flex-direction: column;
    line-height: initial;
    
    span{
        color: #333;
    }
}
.price_style_3_mini{
    justify-content: flex-end;
    >div{
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
}
.del_text{
    color: #999;
}
</style>
